import React, {useEffect, useState} from "react";
import Select from "react-select";
import useWindowDimensions from "../../hook/useWindowDimension";
import {getApiUrl} from "../../utils/getApiUrl";

const ReactSelect = ({refTime, refAgence, refConseillerAgence, etablissement}) => {

    const {width} = useWindowDimensions();
    const [options, setOptions] = useState([])
    const [placeholder, setPlaceholder] = useState("")
    const getOptionLabel = (option) => `AGENCE ${option.libelle} - ${option.adressel1} ${option.adressel2 ? option.adressel2 : ""} -  ${option.cp} ${option.ville}`;
    const [reactSelectClassname, setReactSelectClassname] = useState("")

    useEffect(() => {
        setPlaceholder("Ville ou code postal de votre agence *")
        const getOptions = async () => {
            if (refTime) {
                setOptions([
                    {value: "9h/12h", label: 'Entre 9h et 12h'},
                    {value: "12h/14h", label: 'Entre 12h et 14h'},
                    {value: "14h/17h", label: 'Entre 14h et 17h'},
                    {value: "17h/19h", label: 'Entre 17h et 19h'}
                ])
            } else {
                let url;
                console.log("etalbissment", etablissement)
                if (etablissement.etablissement === "bp") url = `${getApiUrl()}/partners-bpce/list-agences-bp.json`
                else url = `${getApiUrl()}/partners-bpce/list-agences-ce.json`
                console.log("url", url)
                await fetch(url)
                    .then(res => res.json())
                    .then(data => {
                        console.log("response", data)
                        const agences = data
                        setOptions(agences);
                    })
                    .catch(r => {
                        console.log(r);
                    })
            }
        }
        getOptions()
        console.log("options", options)
    }, [refAgence, refConseillerAgence, refTime])
    return (
        <div className={`input-container ${reactSelectClassname}`} id={"react-select"}>
            <Select
                noOptionsMessage={(() => "Aucune option disponible pour cette recherche")}
                getOptionLabel={(refAgence && !refTime) && getOptionLabel || refConseillerAgence && getOptionLabel}
                ref={refTime && refTime || refConseillerAgence && refConseillerAgence || refAgence && refAgence}
                className="basic-single"
                classNamePrefix="select"
                name="color"
                options={options}
                isClearable
                placeholder={""}
                styles={{
                    container: (provided, state) => ({
                        ...provided,
                        width: "100%",
                    }),
                    valueContainer: (provided, state) => ({
                        ...provided,
                        color: "#4F0C28",
                        overflow: "visible"
                    }),
                    placeholder: (provided, state) => ({
                        ...provided,
                        position: "absolute",
                        // top: state.hasValue || state.selectProps.inputValue ? -15 : "50%",
                        // transition: "top 0.1s, font-size 0.1s",
                        fontSize: (state.hasValue || state.selectProps.inputValue) && 13,
                        color: refConseillerAgence ? "#4F0C28FF" : "#FFDED4FF"
                    })
                }}
                onFocus={() => {
                    setReactSelectClassname("active")
                }}
                onBlur={() => {
                    setReactSelectClassname("active behind")
                }}
            />
            <div className={"placeholder"}>
                <p className={reactSelectClassname}>{placeholder}</p>
            </div>
        </div>
    );
}
export default ReactSelect;